import React from "react";

const FluidSVG: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 18c2.48 0 4.5-1.912 4.5-4.315 0-1.814-2.633-5.638-3.86-7.354a.808.808 0 0 0-1.305 0C10.108 8.047 7.5 11.871 7.5 13.685 7.5 16.088 9.494 18 12 18Zm.205-3.138c.332 0 .613.27.613.588 0 .344-.281.589-.613.589-1.483 0-2.66-1.128-2.66-2.55 0-.319.256-.588.614-.588.333 0 .614.27.614.588 0 .76.639 1.373 1.432 1.373Z"
      fill="#1D2948"
    />
  </svg>
);

export default FluidSVG;
